import { all, call, takeEvery, take, put, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import moment from 'moment'
import { liveRespirationSetState as setState } from '../actions'

const socketServerURL = `wss://v9nk4dufp2.execute-api.us-east-1.amazonaws.com/prod`

let socket

// const getProfile = state => state.profile
const getLiveRespiration = (state) => state.liveRespiration

const connectSocket = (payload) => {
  const { jwtToken, deviceId } = payload
  /*
  window.log('token is this', token) */
  socket = new WebSocket(`${socketServerURL}?token=${jwtToken}`)
  return new Promise((resolve) => {
    socket.onopen = () => {
      window.log('umer socketisOpen', socket)
      socket.send(
        JSON.stringify({
          action: 'vcSubscribeDevice',
          room: 'Testing',
          content: 'Live graph web-scoket',
          device_type: 'Web',
          client_id: Math.random() * 1000000 + 1,
          device_id: deviceId || 'b4e62ddefec1',
        }),
      )
      resolve(true)
    }
  })
}

const createSocketChannel = (socketInstance) =>
  eventChannel((emit) => {
    const handler = (data) => {
      emit(data)
    }
    socketInstance.onmessage = handler
    socketInstance.onerror = handler
    return () => {
      socketInstance.onclose = handler
    }
  })

export function* LISTEN_TO_SOCKET({ payload }) {
  yield take
  const { jwtToken, deviceId } = payload
  yield call(connectSocket, { jwtToken, deviceId })

  const socketChannel = yield call(createSocketChannel, socket)
  while (true) {
    const returnedData = yield take(socketChannel)

    let { data } = returnedData
    data = JSON.parse(data)
    window.log('socketChannel', deviceId)
    if (data.device_id && data.device_id === deviceId) {
      const { liveRespirationData, pushDataToGraph, liveRscore } = yield select(getLiveRespiration)
      window.log('socketChannel -date ', moment.duration(pushDataToGraph.end).minutes())
      window.log('socketChannel -date ', moment.duration(new Date().getTime()).minutes())
      if (
        moment.duration(new Date().getTime()).minutes() >=
        moment.duration(pushDataToGraph.end).minutes()
      ) {
        pushDataToGraph.start = new Date().getTime()
        pushDataToGraph.end = new Date(pushDataToGraph.start + 1 * 60000).getTime()
        pushDataToGraph.pushData = true
      }
      const rr = {}
      const rScore = liveRscore
      window.log('socketChannel', JSON.stringify(data))
      if (data.action === 'rr') {
        rr.graph = data
        liveRespirationData.push(rr)
      }
      if (data.action === 'r_score') {
        rScore.upperScore = data.r_score.upper_score
        rScore.lowerScore = data.r_score.lower_score
      }
      yield put(setState({ liveRespirationData, pushDataToGraph, liveRscore: rScore }))
    }
  }
}

export function CLOSE_SOCKET() {
  if (socket) {
    window.log('connection close')
    socket.close()
  }
  return true
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([takeEvery('socket/LISTEN_TO_SOCKET', LISTEN_TO_SOCKET)])
}
